<script setup lang="ts">
import { onMounted, ref, watch } from 'vue'
import type { Publisher, Subscriber } from 'openvidu-browser' // adjust types if needed

// Define the prop
const props = defineProps<{
  streamManager: Publisher | Subscriber
}>()

// Ref to the video DOM element
const videoRef = ref<HTMLVideoElement | null>(null)

// Attach the video element when mounted
onMounted(() => {
  if (props.streamManager && videoRef.value) {
    props.streamManager.addVideoElement(videoRef.value)
  }
})

// (Optional) Re-run if streamManager changes dynamically
watch(
  () => props.streamManager,
  (newManager) => {
    if (newManager && videoRef.value) {
      newManager.addVideoElement(videoRef.value)
    }
  },
)
</script>

<template>
  <video ref="videoRef" autoplay />
</template>

<style lang="scss" scoped></style>
